import {
  APP_CONTAINER_SELECTOR,
  APP_CONTAINER_CLASSNAME
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

const scrollTo = function($container, scrollTop, animationTimeMs=500){
  const $defer = $.Deferred();
  // when the app container is separate we have to figure it out using scrollTop()
  if( !$('body').hasClass(APP_CONTAINER_CLASSNAME) ){
    scrollTop += $(APP_CONTAINER_SELECTOR).scrollTop();
  }
  if (animationTimeMs === 0) {
    $container.scrollTop(scrollTop);
    $defer.resolve();

  } else {
    $container.animate({ scrollTop: scrollTop }, animationTimeMs, $defer.resolve);
  }
  return $defer.promise();
};


const scrollToElement = function($container, $elem, offset, animationTimeMs){
  $elem = $($elem);
  var scrollTop = $elem.offset().top - (offset ? offset : 0);
  return scrollTo($container, scrollTop, animationTimeMs);
};


const scrollToTop = function($container, animationTimeMs=500){
  const $defer = $.Deferred();

  if ($container.scrollTop() === 0) {
    $defer.resolve();

  } else if (animationTimeMs === 0) {
    $container.scrollTop(0);
    $defer.resolve();

  } else {
    $container.animate({ scrollTop: 0 }, animationTimeMs, $defer.resolve);
  }

  return $defer.promise();
};


export default {
  scrollToTop, 
  scrollTo,
  scrollToElement
};

export {
  scrollToTop,
  scrollTo,
  scrollToElement
};
